import { createFileRoute } from '@tanstack/react-router';

import { queryClient } from '~app/query-client';

import { getAllRecitalsOptions } from '~entities/recital-manager/api/get-all-recitals';

import { RecitalListPage } from '~features/recital-manager';

export const Route = createFileRoute('/_auth/_layout/recitals/')({
  component: RecitalListPage,
  loader: async ({ preload }) => {
    // Preload initial recital data with default parameters
    const params = {
      page: 1,
      limit: 10,
    };

    // Use the same queryOptions that the component will use
    const options = getAllRecitalsOptions(params);

    // Preload the data using the queryClient
    await queryClient.ensureQueryData(options);

    return {
      maxAge: preload ? 5 * 60 * 1000 : 0, // Preloaded data stays valid for 5 minutes
    };
  },
});
